import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation, input, output } from '@angular/core';
import {
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import { RoomStatusBadgeComponent } from './room-status-badge.component';

@Component({
  selector: 'era-room-status-dropdown',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './room-status-dropdown.component.html',
  styleUrls: ['./room-status-dropdown.component.scss'],
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    RoomStatusBadgeComponent,
    NgbDropdownMenu,
    NgClass,
    NgbDropdownButtonItem,
    NgbDropdownItem,
  ],
})
export class RoomStatusDropdownComponent {
  readonly positionRight = input(false);
  readonly isCheckedIn = input<boolean>();
  readonly checkInStateChanged = output<boolean>();

  checkin() {
    this.checkInStateChanged.emit(true);
  }

  checkout() {
    this.checkInStateChanged.emit(false);
  }
}
